import { useState } from 'react';
import { ChevronDown, ChevronUp, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ROUTES } from '@constants';

const FAQPage = () => {
  const [openCategory, setOpenCategory] = useState(null);
  const [openQuestion, setOpenQuestion] = useState(null);

  const faqData = [
    {
      category: 'General',
      questions: [
        {
          question: 'What is F.O.W?',
          answer: 'F.O.W (FlatOut Way Consultancy Group) is a Career Clarity platform that helps students, freshers and professionals understand themselves, explore careers, build a career portfolio, generate Clarity Report identify skill gaps and make informed career decisions.'
        },
        {
          question: 'What is a Career Portfolio?',
          answer: 'A Career Portfolio is a personalized report that you create to gain self-clarity and an in-depth understanding of your interests, strengths, and career preferences. It helps you identify the career path that best aligns with your profile, enabling you to make informed academic and professional decisions.'
        },
        {
          question: 'Who can use F.O.W?',
          answer: 'FOW platform helps students, freshers and professionals understand themselves, explore careers.'
        },
        {
          question: 'Why should I use F.O.W?',
          answer: 'FOW provides a simple, secure and personalized experience. The platform offers guidance, recommendations and relevant resources related to career and Education.'
        },
        {
          question: 'How does F.O.W work?',
          answer: 'Purchase a subscription plan, select your profile type, choose your areas of interest, and FOW will generate your personalized career report. If you need help, click the Question Mark (?) icon in the top-left corner to access the tutorial.'
        },
        {
          question: 'Is F.O.W free?',
          answer: 'Yes, Free plan is of 1 Week, after it you have to purchase, choose the plan based on your career stage and required features. Basic is suitable for getting started, higher plans provide deeper insights, recommendations and premium features.'
        },
        {
          question: 'Can I upgrade?',
          answer: 'Absolutely. FOW allows you to upgrade or downgrade your subscription plan whenever you need. Your new plan is activated immediately after the change, giving you instant access to the features included in your selected plan.'
        },
        {
          question: 'How long is my plan valid?',
          answer: 'All FOW paid subscription plans are valid for 30 days from the date of activation. You can renew, upgrade, or downgrade your plan at any time. Your selected plan will become active immediately after the change.'
        },
        {
          question: 'Do plans auto renew?',
          answer: 'No. FOW does not automatically renew your subscription. Once your 1-month plan expires, you can purchase a new plan to continue accessing premium features.'
        },
        {
          question: 'What payment methods?',
          answer: 'FOW uses Razorpay as its secure payment gateway. You can make payments using UPI, QR Code, Credit Cards, Debit Cards, and Net Banking.'
        }
      ]
    },
    {
      category: 'Students',
      questions: [
        {
          question: 'How does FOW help students?',
          answer: 'FOW provides students with direct access to experienced mentors, multiple career roadmaps (including CA, CS, Government Jobs, Teaching, Pharmacy, and more), the ability to build a personalized education portfolio, and tools to explore universities based on their preferred location and career goals.'
        },
        {
          question: 'Can it help after Class 10?',
          answer: 'FOW is designed for Class 10 students, Class 12 students, graduates, postgraduates, freshers, and working professionals who want to explore career options, make informed decisions, and plan their academic or professional journey.'
        }
      ]
    },
    {
      category: 'Freshers',
      questions: [
        {
          question: 'How does FOW help freshers?',
          answer: 'FOW helps freshers discover their areas of interest, explore relevant industries, identify higher education entrance exams, understand different job profiles, and connect with experienced mentors to make informed career decisions.'
        },
        {
          question: 'Career switching?',
          answer: 'Yes. If you\'re planning to switch your career, you can purchase the Pro Plan for ₹1,699. It provides access to various industries, job profiles, the skills required for each role, and the recommended years of experience needed, helping you make an informed career transition.'
        },
        {
          question: 'Improve employability?',
          answer: 'Yes. FOW improves employability by helping freshers identify the right career direction, career path, required skills, and suitable industries. It provides clarity on the job roles that best match their profile, enabling them to build relevant skills and become job-ready with confidence.'
        }
      ]
    },
    {
      category: 'Professionals',
      questions: [
        {
          question: 'How does FOW help professionals?',
          answer: 'You can purchase the Pro Plan for ₹1,699. It provides access to various industries, job profiles in government and private sector both, the skills required for each role, and the recommended years of experience needed, helping you make an informed career transition.'
        }
      ]
    },
    {
      category: 'Mentors',
      questions: [
        {
          question: 'Become a mentor?',
          answer: 'After signing up, select Mentor as your profile type, upload your Aadhaar Card, highest qualification certificate, and other required documents. Our team will verify your application, and once approved, you can start mentoring on FOW.'
        },
        {
          question: 'Mentor benefits?',
          answer: 'Mentors earn based on their ratings and the questions they answer. Mentors with higher ratings are featured in the Top Mentors category and are recommended to more users on the platform.'
        },
        {
          question: 'Update Mentor profile?',
          answer: 'Once your mentor documents are verified, complete your Mentor Profile by adding your experience, skills, expertise, and other required details. Your profile will be visible to students, freshers, and professionals, allowing them to connect with you and ask questions related to your area of expertise.'
        }
      ]
    },
    {
      category: 'Support',
      questions: [
        {
          question: 'Forgot password?',
          answer: 'Click Forgot Password, enter your registered phone number, verify it using the OTP, and create a new password to regain access to your account.'
        },
        {
          question: 'OTP not received?',
          answer: 'In case the OTP doesn\'t arrive, please email your concern along with a screenshot or screen recording to flatoutway@gmail.com. Our support team will assist you as soon as possible.'
        },
        {
          question: 'Can\'t login?',
          answer: 'FOW provides a simple, secure and personalized experience. The platform offers guidance, recommendations and resources relevant to this topic. Refer to your dashboard or contact support for personalized assistance.'
        },
        {
          question: 'Payment successful but plan inactive?',
          answer: 'After purchasing a plan if its inactive, log in to your account, go to Settings from the bottom-left menu, scroll down to Support, and raise a support ticket by selecting your concern. Our team will review and resolve your issue as soon as possible.'
        },
        {
          question: 'Features locked after purchase?',
          answer: 'If your features are locked after purchasing a plan, log in to your account, go to Settings from the bottom-left menu, scroll down to Support, and raise a support ticket by selecting your concern. Our team will review and resolve your issue as soon as possible.'
        },
        {
          question: 'App slow?',
          answer: 'Go to Settings from the bottom-left menu, scroll down to Support, and raise a support ticket by selecting your concern. Our team will review and resolve your issue as soon as possible.'
        },
        {
          question: 'Dashboard not loading?',
          answer: 'Log in to your account, go to Settings from the bottom-left menu, scroll down to Support, and raise a support ticket by selecting your concern. Our team will review and resolve your issue as soon as possible.'
        },
        {
          question: 'Report bug?',
          answer: 'FOW provides a simple, secure and personalized experience. The platform offers guidance, recommendations and resources relevant to this topic. Refer to your dashboard or contact support for personalized assistance.'
        },
        {
          question: 'Contact support?',
          answer: 'Log in to your account, go to Settings from the bottom-left menu, scroll down to Support, and raise a support ticket by selecting your concern. Our team will review and resolve your issue as soon as possible.'
        },
        {
          question: 'Response time?',
          answer: 'Our support team typically responds to support requests within 24 to 48 hours. We appreciate your patience while we review and resolve your concern.'
        }
      ]
    },
    {
      category: 'Payments',
      questions: [
        {
          question: 'Payment failed?',
          answer: 'If your payment fails, you can try again after a few minutes. Payment failures may sometimes occur due to network issues or temporary delays from your bank\'s server.'
        }
      ]
    }
  ];

  const toggleCategory = (index) => {
    if (openCategory === index) {
      setOpenCategory(null);
      setOpenQuestion(null);
    } else {
      setOpenCategory(index);
      setOpenQuestion(null);
    }
  };

  const toggleQuestion = (categoryIndex, questionIndex) => {
    const key = `${categoryIndex}-${questionIndex}`;
    setOpenQuestion(openQuestion === key ? null : key);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-primary-50">
      {/* Header */}
      <div className="bg-gradient-to-r from-primary-600 to-secondary-600 py-5 sm:py-6">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            to={ROUTES.HOME}
            className="inline-flex items-center gap-2 text-white/90 hover:text-white mb-2 transition-colors"
          >
            <ArrowLeft className="w-3.5 h-3.5" />
            <span className="text-xs font-medium">Back to Home</span>
          </Link>
          <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-1.5">
            Frequently Asked Questions
          </h1>
          <p className="text-xs sm:text-sm text-white/90 max-w-3xl">
            Find answers to common questions about F.O.W and how it can help you achieve your career goals.
          </p>
        </div>
      </div>

      {/* FAQ Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-5 sm:py-6">
        <div className="max-w-5xl mx-auto">
          {/* Category Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-2">
            {faqData.map((category, categoryIndex) => {
              const isOpen = openCategory === categoryIndex;
              return (
                <button
                  key={categoryIndex}
                  onClick={() => toggleCategory(categoryIndex)}
                  className={`flex items-center justify-between gap-2 px-3 sm:px-3.5 py-2.5 rounded-lg text-xs sm:text-sm font-semibold transition-all duration-150 border ${
                    isOpen
                      ? 'bg-primary-600 text-white border-primary-600 shadow-sm'
                      : 'bg-white text-primary-800 border-primary-100 hover:border-primary-300 hover:bg-primary-50'
                  }`}
                >
                  <span className="truncate">{category.category}</span>
                  {isOpen ? (
                    <ChevronUp className="w-4 h-4 flex-shrink-0" />
                  ) : (
                    <ChevronDown className="w-4 h-4 flex-shrink-0 text-primary-400" />
                  )}
                </button>
              );
            })}
          </div>

          {/* Questions Panel — only renders once a category is selected */}
          {openCategory !== null && (
            <div
              key={openCategory}
              className="mt-4 sm:mt-6 bg-white rounded-xl border border-primary-100 shadow-sm divide-y divide-primary-50 overflow-hidden animate-[fadeIn_0.2s_ease-out]"
            >
              {faqData[openCategory].questions.map((item, questionIndex) => {
                const qKey = `${openCategory}-${questionIndex}`;
                const isQOpen = openQuestion === qKey;
                return (
                  <div key={questionIndex}>
                    <button
                      onClick={() => toggleQuestion(openCategory, questionIndex)}
                      className="w-full px-4 sm:px-5 py-3.5 sm:py-4 flex items-center justify-between text-left hover:bg-primary-50/60 transition-colors duration-150"
                    >
                      <span className="text-sm sm:text-[15px] font-medium text-primary-800 pr-3 leading-snug">
                        {item.question}
                      </span>
                      {isQOpen ? (
                        <ChevronUp className="w-4 h-4 text-secondary-600 flex-shrink-0" />
                      ) : (
                        <ChevronDown className="w-4 h-4 text-secondary-600 flex-shrink-0" />
                      )}
                    </button>
                    {isQOpen && (
                      <div className="px-4 sm:px-5 pb-4 -mt-1">
                        <p className="text-sm text-primary-600 leading-relaxed">
                          {item.answer}
                        </p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}

          {openCategory === null && (
            <div className="mt-4 sm:mt-6 text-center py-12 sm:py-16 px-4 bg-white rounded-xl border border-primary-100 min-h-[260px] sm:min-h-[400px] flex items-center justify-center">
              <p className="text-sm sm:text-base text-primary-600">
                Select a category above to view questions
              </p>
            </div>
          )}
        </div>

        {/* Contact Support */}
        <div className="mt-10 sm:mt-12 text-center px-4">
          <p className="text-sm text-primary-600 mb-4">
            Still have questions? We're here to help!
          </p>
          <a
            href="mailto:flatoutway@gmail.com"
            className="inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-primary-600 to-secondary-600 text-white text-sm font-semibold rounded-lg hover:from-primary-700 hover:to-secondary-700 transition-all duration-200 shadow-md hover:shadow-lg"
          >
            Contact Support
          </a>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;